// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__3YI6F","container":"LayoutSideNavigation_container__7eyem","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2TfS9"};